<div>
    <div class="row">
        <div class="col-xl-12">
            <div class="card-box">
                <button class="btn btn-primary" @click="downloadBol">Download BOL</button>
                <br>
                <br>
                <div v-if="!loading">
                    <div class="card border border-secondary mb-3">
                        <div class="card-body text-secondary">
                            <div class="row">
                                <div class="col-6">
                                    <p>
                                        <b>Customer:</b> {{order.registeredCompanyName}}
                                    </p>
                                    <p>
                                        <b>Order Date:</b> {{order.insertedOn}}
                                    </p>
                                    <p>
                                        <b>Order Type:</b> {{order.orderType}}
                                    </p>
                                    <p>
                                        <b>Order Status:</b> {{order.orderStatus}}
                                    </p>
                                    <p>
                                        <b>Customer Purchase Order Number:</b> {{order.customerPurchaseOrder}}
                                    </p>
                                    <p>
                                        <b>Transporter:</b> {{order.customerPurchaseOrder}}
                                    </p>
                                    <p>
                                        <b>Vehicle Make:</b> {{order.vehicleMake}}
                                    </p>
                                    <p>
                                        <b>Vehicle Model:</b> {{order.vehicleModel}}
                                    </p>
                                    <p>
                                        <b>Vehicle Registration:</b> {{order.vehicleRegistration}}
                                    </p>
                                    <p v-if="order.expectedUpliftmentDate !== null && order.expectedUpliftmentDate !== undefined">
                                        <b>Expected Upliftment:</b> {{order.expectedUpliftmentDate}}
                                    </p>
                                </div>
                                <div class="col-6">
                                    <h5 class="card-title text-secondary">Billing Address</h5>
                                    <p v-if="!loadingBillingAddress">
                                        <span v-if="billingAddress">
                                            {{ billingAddress.siteName }}<br>
                                            {{ billingAddress.streetAddress }}<br>
                                            {{ billingAddress.city }} <br>
                                            {{ billingAddress.province }} <br>
                                            {{ billingAddress.postalCode }}<br>
                                            <!--                                {{ billingAddress.country }}-->
                                        </span>
                                        <span v-else>
                                            No billing address found.
                                        </span>
                                    </p>
                                    <p v-if="loadingBillingAddress">Loading...</p>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div class="form-group">
                        <label>BOL Loading Date</label>
                        <div class="text-danger" v-if="bolLoadingDate.hasError">
                            {{bolLoadingDate.errorMessage}}
                        </div>
                        <date-picker :format="'DD/MM/YYYY'" :elementId="'bolLoadingDateSelect'" :date="bolLoadingDate.value"
                                     :initialiseDate="bolLoadingDate.initialiseDate"
                                     @dateChange="onBolLoadingDateChange"></date-picker>
                    </div>
                    <div class="text-danger" v-if="orderItemsDispensed.hasError">
                        {{orderItemsDispensed.errorMessage}}
                    </div>
                    <dispense-order-item-for-order-table
                            :orderId="order.orderId"
                            :orderTypeId="orderTypeId"
                            @dispenseUpdate="onDispenseUpdate"></dispense-order-item-for-order-table>
                    <br>
                    <br>
                    <button class="btn btn-primary" :disabled="loading" @click="completeOrder">Save</button>
                </div>
                <loading-spinner :showSpinner="loading"></loading-spinner>
            </div>
        </div>
    </div>

    <success-modal
            :modalHeading="successModal.modalHeading"
            :elementId="'reviewOrderSuccessModal'"
            :modalMessage="successModal.modalMessage"
            :showModal="successModal.showModal"
            @okClicked="onSuccessModalOkClick">

    </success-modal>
</div>
